<style lang="less" scoped>
  .td_left {width: 150px;text-align-last: left;text-indent: 10px;background-color: #fcfcfc;}
  .after {text-align: left;background-color: #fcfcfc;}
  .after .el-button {height: 40px;}
  .detection_btn {margin-left: 10px;}
  .f_red {color: red;margin-right: 5px;}
  .f_hid {color: #ffffff;margin-right: 5px;}
  tr,td {border: 1px solid #f5eeee;padding: 5px;border-bottom: 1px solid #f5eeee;}
  .tr .td {float: left;}
  .tr {width: 100%;height: 50px;}
  .td {margin-left: 10px;}
  table {border-collapse: collapse;width: 100%;}
  .el-checkbox__inner {border-radius: 50%;}
  .first .detection_btn {width: 100px;}
  .first .introduce {width: 100%;}
  .first /deep/ .el-input {width: 400px;}
  .level /deep/ .el-input {width: 200px;}
  .ssgj_tr /deep/ .el-input {width: 400px;}
  .edui-default /deep/ .edui-editor-iframeholder {height: 40%;}
  .el-form-item {margin-bottom: 0;float: left;}
  .jianjie_tr .el-form-item {width: 100%;}
  .catid_tr .el-form-item:nth-of-type(2) {margin-left: 10px;}
  .tr2 .el-form-item:nth-of-type(2) {margin-left: 10px;}
  /deep/.el-upload-list--picture-card .el-upload-list__item-thumbnail {position: absolute;margin: auto;top: -9999px;right: -9999px;bottom: -9999px;left: -9999px;height: auto}
  .formBox {padding-bottom: 70px;}
  .btnfixed {margin: 0px auto;height: 60px;z-index: 19999;}
  .btnfixed .el-button {height: 40px;margin: 10px auto;}
  .btnfixed {position: fixed;bottom: 0;left: 0;right: 0;height: 60px;background: #f8f4f4;margin-left: 240px;background-color: #dff0d8;}
  /deep/.el-form-item__error {font-size: 16px;height: 40px;line-height: 40px;float: right;margin-left: 10px;position:static;padding-top: 0;}
  /deep/.el-icon-close-tip {display: none;}
  /deep/.el-dialog__wrapper {z-index: 20000 !important;}
</style>
<template>
  <div class="first" id="first">
    <el-form ref="form" :model="form" class="formBox">
      <table>
        <tr class="catid_tr">
          <td class="td_left">
            <span v-if="this.isMandatory(this.tableNameDate, 'glid')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>所属分类
          </td>
          <td class="after">
            <el-form-item>
              <el-select clearable v-model="form.glid" placeholder="请选择分类" class="select classification">
                <el-option v-for="(item,index) in classifydata" :key="index" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </td>
        </tr>
        <tr class="tr2">
          <td class="td_left">
            <span v-if="this.isMandatory(this.tableNameDate, 'name')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>名称
          </td>
          <td class="after title_right">
            <el-form-item>
              <el-input v-model="form.name" class="input title"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button class="detection_btn" @click="detection(11, 75, form.name)">标题检测</el-button>
            </el-form-item>
          </td>
        </tr>
        <tr class="tr2">
          <td class="td_left">
            <span v-if="this.isMandatory(this.tableNameDate, 'namee')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>英文名称
          </td>
          <td class="after title_right">
            <el-form-item>
              <el-input v-model="form.namee" class="input title"></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr class="tr2">
          <td class="td_left">
            <span v-if="this.isMandatory(this.tableNameDate, 'type1')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>类型
          </td>
          <td class="after title_right">
            <el-form-item>
              <el-input v-model="form.type1" class="input title"></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr class="tr2">
          <td class="td_left">
            <span v-if="this.isMandatory(this.tableNameDate, 'country')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>所属国家
          </td>
          <td class="after">
            <el-form-item>
              <el-select clearable v-model="form.country" placeholder="请选择所属国家" class="select level" :popper-append-to-body="false">
                <el-option v-for="item in ssgj_data" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </td>
        </tr>
        <tr class="tr2">
          <td class="td_left">
            <span v-if="this.isMandatory(this.tableNameDate, 'x')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>经度
          </td>
          <td class="after title_right">
            <el-form-item>
              <el-input v-model="form.x" class="input title"></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr class="tr2">
          <td class="td_left">
            <span v-if="this.isMandatory(this.tableNameDate, 'y')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>纬度
          </td>
          <td class="after title_right">
            <el-form-item>
              <el-input v-model="form.y" class="input title"></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr class="tr2">
          <td class="td_left">
            <span v-if="this.isMandatory(this.tableNameDate, 'url')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>URL
          </td>
          <td class="after title_right">
            <el-form-item>
              <el-input v-model="form.url" class="input title"></el-input>
            </el-form-item>
          </td>
        </tr>
      </table>
    </el-form>
    <div class="btnfixed">
      <el-button type="success" @click="addfn()" v-if="this.$route.path === '/KyxxMap'">添加</el-button>
      <el-button type="success" @click="modification" v-else-if="this.$route.path === '/MineUpdate'">确定</el-button>
      <el-button @click="cancelfn()" v-if="this.$route.path === '/KyxxMap'">取消</el-button>
      <el-button @click="backtrack" v-else-if="this.$route.path === '/MineUpdate'">返回</el-button>
    </div>
  </div>
</template>
<script>
/**
 * 李旭
 * 矿业信息地图后台添加页
 */
import treeOrder from '../../src/plugins/backer/method/tree.js'
import {mapState} from 'vuex'
export default {
  components: {
  },
  props: ['updataID'],
  data()
  {
    return {
      url: '',
      form: {
        glid: null,
        name: '',
        namee: '',
        type1: '',
        x: '',
        y: null,
        url: '',
        country: ''
      },
      //所属分类数据
      classifydata: [],
      //fld数据
      tableNameDate: null,
      ssgj_data: [
        { value: 0, label: '不限地区' },
        { value: 2, label: '中国' },
        { value: 3, label: '印度尼西亚' },
        { value: 4, label: '马来西亚' },
        { value: 5, label: '菲律宾' },
        { value: 6, label: '新加坡' },
        { value: 7, label: '泰国' },
        { value: 8, label: '文莱' },
        { value: 9, label: '越南' },
        { value: 10, label: '老挝' },
        { value: 11, label: '缅甸' },
        { value: 12, label: '柬埔寨' },
        { value: 13, label: '其它' },
        { value: 14, label: '东帝汶' }
      ],
      tabname: 'swms'
    }
  },
  //根据左侧菜单栏获取模块id
  computed:
  {
    ...mapState({
      curID: state => state.NavID
    })
  },
  watch:
  {
    curID:
    {
      handler(nval, oval)
      {
        //获取分类下拉列表
        window.public.getFldvalue(nval, 'catid').then((ret) =>
        {
          this.classifydata = []
          this.classifydata = this.classifydata.concat(treeOrder.TreeThree(ret))
        })
      },
      immediate: true
    }
  },
  async created()
  {
    this.tableNameDate = await window.public.validation(this.tabname)
    this.isgetData()
  },
  methods: {
    //添加
    addfn()
    {
      let obj = {
        cmd: 'add',
        _major: 11,
        _minor: 75,
        retAtt: 1,
        glid: this.form.glid,
        name: this.form.name,
        namee: this.form.name,
        type1: this.form.type1,
        country: this.form.country,
        x: this.form.x,
        y: this.form.y,
        url: this.form.url
      }
      window.post.getPost(obj).then((ret) =>
      {
        if (ret.ret === 1)
          this.$message({message: '添加失败，请检查是否有未填写的内容或者填写不规范', type: 'error', customClass: 'mzindex'})
        else
        {
          this.$message({message: '添加成功', type: 'success', customClass: 'mzindex'})
          this.$emit('removeTab')
          this.$store.commit('onIsLb', '1')
        }
      })
    },
    //获取需要修改的数据
    isgetData()
    {
      if (this.$route.path === '/MineUpdate')
        this.getData()
    },
    getData()
    {
      let paras = {
        cmd: 'query',
        _major: 11,
        _minor: 75,
        _exp: 'id=?',
        types: 'i',
        vals: this.updataID
      }
      window.post.getPost(paras).then((ret) =>
      {
        this.form.id = ret[0].id
        this.form.glid = ret[0].glid
        this.form.name = ret[0].name
        this.form.namee = ret[0].namee
        this.form.country = ret[0].country
        this.form.type1 = ret[0].type1
        this.form.x = ret[0].x
        this.form.y = ret[0].y
        this.form.url = ret[0].url
      })
    },
    //修改
    modification()
    {
      let obj = {
        cmd: 'updateAtt',
        _major: 11,
        _minor: 75,
        retAtt: 1,
        id: this.form.id,
        glid: this.form.glid,
        name: this.form.name,
        namee: this.form.name,
        type1: this.form.type1,
        country: this.form.country,
        x: this.form.x,
        y: this.form.y,
        url: this.form.url
      }
      window.post.getPost(obj).then((ret) =>
      {
        if (ret.ret === 1)
          this.$message({message: '修改失败', type: 'error', customClass: 'mzindex'})
        else
        {
          this.$message({message: '修改成功', type: 'success', customClass: 'mzindex'})
          this.dialogVisible = false
          this.$router.push({path: '/KyxxMap'})
          this.$store.commit('onActiveName', '1')
        }
      })
    },
    //返回
    backtrack()
    {
      this.$router.push({path: '/KyxxMap'})
      this.$store.commit('onActiveName', '1')
    },
    /**
     * 标题检测
     * @param {String} major 主类型
     * @param {String} minor 子类型
     * @param {String} title 标题
     */
    detection(major, minor, title)
    {
      let that = this
      window.public.detection(major, minor, title, that)
    },
    //判断是否必填
    isMandatory(ret, colname)
    {
      if (ret)
      {
        for (let i = 0; i < ret.length; i++)
        {
          if (colname === ret[i].colname && ret[i].nullable === 0)
            return true
        }
      }
      else
        return false
    },
    //取消(移除Tabs页)
    cancelfn()
    {
      this.$emit('removeTab')
    }
  }
}
</script>



// WEBPACK FOOTER //
// static/form/MineAdd.vue